module.exports = __webpack_public_path__ + "202408221624/img/img_id_card_f_200_125@2x.c944c7d6.png";